/**
 * Unlisted public marketing pages — direct URL, noindex, not in nav/sitemap.
 *
 * Kept as a small inventory so a future Pages admin surface (or parallel
 * inventory PR) can list these as `unlisted` without scraping App.tsx.
 * Adding a route here does not register the page; App.tsx + known-routes
 * remain the source of truth for routing.
 */
export const UNLISTED_PUBLIC_PAGES = [
  {
    path: "/overview",
    title: "EB-5 Overview",
    visibility: "unlisted" as const,
    noindex: true,
  },
  {
    path: "/energy-briefing",
    title: "Energy EB-5 Briefing",
    visibility: "unlisted" as const,
    noindex: true,
  },
  {
    path: "/partner-briefing",
    title: "How We Work with Partners",
    visibility: "unlisted" as const,
    noindex: true,
  },
  {
    path: "/pricing",
    title: "EB-5 Pricing",
    visibility: "unlisted" as const,
    noindex: true,
  },
] as const;
